export default "__VITE_ASSET__BOuX2itJ__"